export default __webpack_public_path__ + "static/media/6.d5926d09.jpeg";